import { MerchantBookingPageApiResponse } from './bookings';

export interface MerchantProductImage {
  url?: string;
  thumb: {
    url?: string;
  };
  small: {
    url?: string;
  };
  medium: {
    url?: string;
  };
  large: {
    url?: string;
  };
}

export enum MerchantProductStatus {
  Unpublished = 'unpublished',
  NotForSale = 'not_for_sale',
  Accepting = 'accepting',
}

export interface MerchantProduct {
  public_id: string;
  name: string;
  description?: string;
  wait_first_anchor: boolean;
  scheme: number;
  status: MerchantProductStatus;
  price: number;
  image: MerchantProductImage;
  ticket_count: number;
  expiration: number;
  booking_pages?: MerchantBookingPageApiResponse[];
}

export interface MerchantProductIndex {
  total_size: number;
  total_pages: number;
  current_page: number;
  data: MerchantProduct[];
}
